import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ThemeContext } from '../../App'
import { ITHORStakingStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getTSThorStakingConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorswap', 'thor_staking_stats', timeframe)) as ITHORStakingStats[]
	const series1 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VTHOR_TVL }
	})
	const series2 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.UTHOR_TVL }
	})
	const series3 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.YTHOR_TVL }
	})
	const series4 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_THOR_STAKED }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'vThor',
			type: 'bars',
			seriesGroup: '[thor]',
			color: 'orange',
			unitSymbol: '',
			barGroup: 'thor'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'uThor',
			type: 'bars',
			seriesGroup: '[thor]',
			color: 'green',
			unitSymbol: '',
			barGroup: 'thor'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'yThor',
			type: 'bars',
			seriesGroup: '[thor]',
			color: '#0ffc03',
			unitSymbol: '',
			barGroup: 'thor'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'total',
			type: 'line',
			seriesGroup: ' [thor]',
			color: `${color}`,
			unitSymbol: ''
		}
	]
	return { config: config, latestValue: series4[series4.length - 1].y, latestValueDate: series4[series4.length - 1].x }
}

const TSThorStaking = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTSThorStakingConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="THOR Staking TVL"
			chartDesc="Amount of THOR locked in v/u/y contracts."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="7a055efe-72db-4ee0-b542-d4fa0541c84d"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default TSThorStaking
